import React from 'react';
import { Col, Row } from 'react-bootstrap';

import * as Ph from '~/App/Components/Placeholder';

export function Loading() {
  return (
    <Row>
      <Col md={6}>
        <Ph.Item>
          <Ph.Col size={2}>
            <Ph.Avatar />
          </Ph.Col>
          <Ph.Col size={8}>
            <Ph.Row>
              <Ph.Col size={12} empty />
              <Ph.Col size={12} big />
            </Ph.Row>
          </Ph.Col>
        </Ph.Item>
      </Col>
      <Col md={12}>
        <Ph.Item>
          <Ph.Col size={12}>
            <Ph.Row>
              <Ph.Col size={2} big />
            </Ph.Row>
          </Ph.Col>
          <Ph.Col size={12}>
            <Ph.Row>
              <Ph.Col size={12} />
              <Ph.Col size={12} />
              <Ph.Col size={12} />
              <Ph.Col size={12} />
            </Ph.Row>
          </Ph.Col>
        </Ph.Item>
      </Col>
      <Col md={12}>
        <Ph.Item>
          <Ph.Col size={12}>
            <Ph.Row>
              <Ph.Col size={2} big />
            </Ph.Row>
          </Ph.Col>
          <Ph.Col size={12}>
            <Ph.Row>
              <Ph.Col size={12} />
              <Ph.Col size={12} />
              <Ph.Col size={12} />
              <Ph.Col size={12} />
            </Ph.Row>
          </Ph.Col>
        </Ph.Item>
      </Col>
      <Col md={12}>
        <Ph.Item>
          <Ph.Col size={12}>
            <Ph.Row>
              <Ph.Col size={2} big />
            </Ph.Row>
          </Ph.Col>
          <Ph.Col size={12}>
            <Ph.Row>
              <Ph.Col size={12} />
              <Ph.Col size={12} />
              <Ph.Col size={12} />
              <Ph.Col size={12} />
            </Ph.Row>
          </Ph.Col>
        </Ph.Item>
      </Col>
    </Row>
  );
}
